import React from 'react';
import { View, Modal, Animated } from 'react-native';
import { PanGestureHandler, State } from 'react-native-gesture-handler';
import { useCssStyle } from '../../customHook/getCssStyle';
import FadeTransition from '../fadeTransition';
import CustomPressable from '../customPressable/customPressable';

export const CustomModal = ({ onRequestClose, children }) => {
    const getStyles = useCssStyle();
    const SWIPE_THRESHOLD = 150;
    const translateY = new Animated.Value(0);

    const onGestureEvent = Animated.event(
        [{ nativeEvent: { translationY: translateY } }],
        {
            useNativeDriver: false,
            listener: ({ nativeEvent }) => {
                if (nativeEvent.translationY < 0) {
                    translateY.setValue(0);
                }
            },
        }
    );

    const onHandlerStateChange = ({ nativeEvent }) => {
        if (nativeEvent.state === State.END) {
            if (nativeEvent.translationY > SWIPE_THRESHOLD && onRequestClose) {
                onRequestClose();
            } else {
                Animated.spring(translateY, {
                    toValue: 0,
                    useNativeDriver: false,
                }).start();
            }
        }
    };

    const gestureContent = (
        <Animated.View
            style={[
                getStyles(['customModalInnerContainer']),
                { transform: [{ translateY }] },
            ]}
        >
            {children}
        </Animated.View>
    );

    return (
        <View style={getStyles(['customModalContainer'])}>
            <FadeTransition duration={250}>
                <View style={{ flex: 1, backgroundColor: "rgba(0,0,0,0.5)", borderRadius: 4 }} />
            </FadeTransition>

            <Modal visible={true} transparent statusBarTranslucent animationType="slide" onRequestClose={onRequestClose}>
                <View style={{ flex: 1 }}>
                    <CustomPressable
                        onPress={onRequestClose ?? null}
                        style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'transparent'}}
                    />
                    {onRequestClose ? (
                        <PanGestureHandler
                            onGestureEvent={onGestureEvent}
                            onHandlerStateChange={onHandlerStateChange}
                        >
                            <Animated.View
                                style={[
                                    getStyles(['customModalInnerContainer']),
                                    { transform: [{ translateY }] },
                                ]}
                            >
                                {children}
                            </Animated.View>
                        </PanGestureHandler>
                    ) : (
                        <View style={getStyles(['customModalInnerContainer'])}>
                            {children}
                        </View>
                    )}
                </View>
            </Modal>
        </View>
    );
};
